import { FC } from 'react';
import { useSelector } from 'react-redux';
import { getLoanVariablesDialogState } from 'store/selectors/loanVariablesDialog.selector';

import { BalloonFieldsContainer, BalloonFieldWrapper } from './styles';
import { FieldsRow } from '../styles';
import { Loader } from '../Loader';
import { AFG_TRIM_FIELD } from '../consts/fieldConfig.const';

export const BalloonPaymentRow: FC<{
  isPrintView: boolean;
  generateFields: any;
  generatedFields: any;
  isBalloonRowAnimated: boolean;
  isFetchingBalloonResidualValues: boolean;
  residualFetchFailed: boolean;
}> = ({
  isPrintView,
  generateFields,
  generatedFields,
  isBalloonRowAnimated,
  isFetchingBalloonResidualValues,
  residualFetchFailed,
}) => {
  const { selectedBalloonVehicle, balloonVehicleInfoFlags, balloonResidualValues } = useSelector(
    getLoanVariablesDialogState,
  );

  const showBalloonFields = !!selectedBalloonVehicle && !!balloonResidualValues;
  const isAwaitingResidualData = !!selectedBalloonVehicle && !balloonResidualValues && !residualFetchFailed;
  const showLoader =
    !showBalloonFields &&
    (balloonVehicleInfoFlags.isFetching ||
      isBalloonRowAnimated ||
      isFetchingBalloonResidualValues ||
      isAwaitingResidualData);
  const showAfgTrimField = !showLoader && !selectedBalloonVehicle && !balloonVehicleInfoFlags.isInvalid;
  const balloonOptionFields = isPrintView ? generatedFields.balloonLabels : generatedFields.balloonFields;

  return (
    <BalloonFieldsContainer isPrintView={isPrintView}>
      <BalloonFieldWrapper>
        <FieldsRow style={{ display: showAfgTrimField ? 'block' : 'none' }}>
          {generateFields([AFG_TRIM_FIELD])}
        </FieldsRow>
        {showLoader && <Loader isWithMargins={false} />}
        {showBalloonFields && <FieldsRow>{balloonOptionFields}</FieldsRow>}
      </BalloonFieldWrapper>
    </BalloonFieldsContainer>
  );
};
